import { TagDimension } from '@prisma/client';
import { fetcher } from '@commenda/utils';

import { IApiResponse } from './types';

export interface IAddTagsToFileParams {
  fileId: number;
  data: {
    tags: string[];
    dimension: TagDimension;
  };
}

export async function addTagsToFile({
  fileId,
  data,
}: IAddTagsToFileParams): Promise<IApiResponse<{ addedCount: number }>> {
  const response = await fetcher('drive-view/file/tags', {
    method: 'POST',
    body: { fileId, data },
  });

  if (!response.ok) {
    const body = await response.json().catch(() => ({}));
    return {
      success: false,
      error: body?.message || 'Failed to add tags',
      statusCode: response.status,
      data: null,
    };
  }

  const body = await response.json();
  return {
    success: true,
    error: null,
    statusCode: response.status,
    data: body,
  };
}
